import * as React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "~/design-system/Box";
import { Text } from "~/design-system/Text";

interface StorageIndicatorProps {
  totalSize: number;
  maxStorage: number;
}

export const StorageIndicator: React.FC<StorageIndicatorProps> = ({
  maxStorage,
  totalSize,
}) => {
  const { t } = useTranslation();
  const storagePercentage = (totalSize / maxStorage) * 100;

  return (
    <Box>
      <Box
        css={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Text size="xsmall" tone="neutral">
          {t("Storage")}
        </Text>
        <Text size="xsmall" tone="neutral">
          {`${(totalSize / (1024 * 1024)).toFixed(1)} MB / ${(
            maxStorage /
            (1024 * 1024 * 1024)
          ).toFixed(1)} GB`}
        </Text>
      </Box>
      <Box
        css={{
          backgroundColor: "$neutral200",
          borderRadius: "$small",
          height: "4px",
          marginTop: "$xxsmall",
          overflow: "hidden",
        }}
      >
        <Box
          css={{
            backgroundColor:
              storagePercentage > 80 ? "$critical500" : "$brandAccent500",
            height: "100%",
            transition: "width 0.3s ease",
            width: `${Math.min(storagePercentage, 100)}%`,
          }}
        />
      </Box>
    </Box>
  );
};
